/**
 * 選考管理機能のz-index定数
 * オーバーレイコンポーネントの重なり順を一元管理
 */
export const Z_INDEX = {
  /** ドロワー（詳細表示） */
  DRAWER: 200,
  /** ドロワー（作成・編集、詳細ドロワーの上に表示） */
  FORM_DRAWER: 250,
  /** モーダル（削除確認など、ドロワーの上に表示） */
  MODAL: 300,
  /** 確認モーダル（他のモーダルの上に表示） */
  CONFIRM_MODAL: 350,
} as const;
